// -----------------------------------------------------------------------------
// Scripts for menu activities
// -----------------------------------------------------------------------------

function menuActivities() {

  var menuItem = $('.header .menu-activities');
  var menuContent = $('.menu-activities__content');

  menuItem.append(menuContent);

  // Menu level 0
  $('.menu-activities').hover(function () {

    menuContent.finish().fadeIn(300);
  }, function () {
    menuContent.finish().fadeOut(300);
  });


  // Submenu - level 1
  $('.menu-activities__cat-item').hover(function () {

    $(this).find('.menu-activities__posts-wrapper').finish().fadeIn(300);
    $('.menu-activities__category').finish().addClass('menu-activities__category--active');
    $(this).find('.menu-activities__cat-link').finish().addClass('menu-activities__cat-link--active');
  }, function () {
    $(this).find('.menu-activities__posts-wrapper').finish().fadeOut(300);
    $('.menu-activities__category').finish().removeClass('menu-activities__category--active');
    $(this).find('.menu-activities__cat-link').finish().removeClass('menu-activities__cat-link--active');
  });


  // Submenu - level 2
  $('.menu-activities__post-item').hover(function () {

    $(this).find('.menu-activities__region-wrapper').finish().fadeIn(300);
    $('.menu-activities__posts').finish().addClass('menu-activities__posts--active');
    $(this).find('.menu-activities__post-title').finish().addClass('menu-activities__post-title--active');
  }, function () {
    $(this).find('.menu-activities__region-wrapper').finish().fadeOut(300);
    $('.menu-activities__posts').finish().removeClass('menu-activities__posts--active');
    $(this).find('.menu-activities__post-title').finish().removeClass('menu-activities__post-title--active');
  });

}